module.exports = __webpack_public_path__ + "static/media/checked-file.9a89d321.svg";